<template>
<v-container fluid>
  <modal-delete :dialog = "dialogDelete" @close = "dialogDelete =false; deleteIndex = -1;" @confirm = "deleteField" ></modal-delete>
   
    <v-row>
        <v-dialog v-model="showDialog" width="600px">
          <v-card v-if= "selectedField">
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="showDialog = false">
                Fechar
              </v-btn>
            </v-card-actions>
            <v-card-title>
              <span v-if= "!selectedField.id" class="headline">Novo campo</span>
                <span v-else class="headline">Editar campo </span>
            </v-card-title>
            <v-card-text>
                   <v-row class="ma-4">
               <v-text-field
         
                label="Id"
                hide-details="auto"
                v-model="selectedField.id"
              ></v-text-field>
             </v-row>

             <v-row class="ma-4">
               <v-text-field
         
                label="Nome"
                hide-details="auto"
                v-model="selectedField.description"
              ></v-text-field>
             </v-row>
      <v-row class="ma-4">
              <vuetify-money
                  label="Valor"
                    style="width:100%"
                    v-model.number="selectedField.value"
                    v-bind:options="$globalFunctions.optionsDecimal"
                  />
      </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
          <v-btn class="primary" @click="saveField">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-row>


 <v-row class="ma-4" >
       <div
                class="text-h3 "
                :class="`blue-grey--text text--darken-2` "
                color= ""
          
              >Campos       
      
       </div>
      <v-spacer></v-spacer>
      <!-- <v-btn class="primary" @click="newProject"> +Novo </v-btn> -->
  </v-row>  
    <v-card>
        <v-toolbar class="primary"  dark>
            <span>Campos</span>
            <v-spacer></v-spacer>
            <v-btn class="secondary" @click="addField">Novo</v-btn>
        </v-toolbar>
        <v-card-text>
            <v-row class="ma-4"  v-for="(field, index) in fields" :key="index">
                    <v-btn class="secondary" @click="showDialogDelete(index)"> <v-icon>mdi-delete</v-icon></v-btn>
                    <!-- @click="deleteField(index)" -->
                    
              <v-text-field
                :disabled="true"
                label="Campo"
                hide-details="auto"
                v-model="field.description"
              ></v-text-field>
              
              <v-text-field
                :disabled="true"
                label="Valor"
                hide-details="auto"
                v-model="field.value"
              ></v-text-field>
               <v-btn class="primary" @click="editField(index)"> <v-icon>mdi-pencil</v-icon></v-btn>
            </v-row>
                
                
        </v-card-text>

    </v-card>
</v-container>

</template>

<script>
import Field from "../../../../libraries/classes/Field"
import hebelApi from '../../../../libraries/hebel/hebelApi'
import ModalDelete from '../../components/modals/ModalDelete.vue'
export default {
  name: "Fields",
   components:{
      ModalDelete
  },
    data(){
        return{
            showDialog:false,
            selectedField:{},
            fields:[],
            dialogDelete:false,
            deleteIndex:-1,

        }
    },
    async created(){
        this.fields = await hebelApi.fields.getAll();
    },
    methods:{
      showDialogDelete(index){
        this.deleteIndex = index;
        this.dialogDelete =true;
        },
        deleteField() {
          if(this.deleteIndex !== -1){
            var field = this.fields[this.deleteIndex];
            hebelApi.fields.delete(field.id);
            this.fields.splice(this.deleteIndex , 1);
          }
          this.dialogDelete = false;
        },

        editField(index){
            this.selectedField = this.fields[index];
            this.showDialog = true;
        },
        addField(){
             this.selectedField = new Field();
            this.showDialog =true;
        },
      //  async  deleteField(index){
      //       await hebelApi.fields.delete(this.fields[index].id);
      //       this.fields.splice(index,1)
      //   },
        async saveField(){
            var d = await hebelApi.fields.upsert(this.selectedField)
            this.fields = await hebelApi.fields.getAll();
            this.$forceUpdate();
            this.showDialog= false;
        }
    }
    

}
</script>

<style lang="scss">

</style>